import React, { useEffect, useState } from "react"
import { ToastContainer,ToastPosition} from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const ResponsiveToast: React.FC  = () => {
    const [position, setPosition] =useState<ToastPosition>("bottom-left")

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setPosition("top-right")   // mobile
            } else {
                setPosition("bottom-left") // desktop
            }
        }

        handleResize() // set initial
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    return <ToastContainer position={position} />
}

export default ResponsiveToast
